import { useRoutes } from 'react-router-dom';

// routes
import MainRoutes from './MainRoutes';
import BlogRoutes from './BlogRoutes';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    return useRoutes([MainRoutes, BlogRoutes]);
}
